import React, { ReactElement, useCallback, useEffect, useRef } from 'react';

/**
 * Component that run callbacks if you click outside or inside of children component
 */
type Props = {
    children: ({ ref }) => ReactElement | null;
    onInnerClick?: () => void;
    onOuterClick?: () => void;
    eventType?: 'click' | 'mousedown' | 'mouseup';
};

const ClickTrigger = React.forwardRef<HTMLDivElement, Props>(
    ({ children, onInnerClick, onOuterClick, eventType = 'click' }, ref) => {
        const innerRef = (ref as React.RefObject<HTMLDivElement>) || useRef<HTMLDivElement>(null);

        useEffect(() => {
            if (innerRef.current) {
                document.getElementById('root').addEventListener(eventType, handleClick, false);

                return () => {
                    document
                        .getElementById('root')
                        .removeEventListener(eventType, handleClick, false);
                };
            }
        }, []);

        const handleClick = useCallback(
            (event) => {
                if (innerRef.current == null) return;

                if (innerRef.current.contains(event.target)) {
                    // inner click
                    onInnerClick && onInnerClick();
                } else {
                    // outer click
                    onOuterClick && onOuterClick();
                }
            },
            [innerRef.current]
        );

        return children({ ref: innerRef });
    }
);

export default ClickTrigger;
